<template>
  <v-dialog v-model="dialog" max-width="60%">
    <template #activator="{ on }">
      <slot name="button" :on="on">
        <v-btn outlined v-on="on" color="primary">
          New Batch
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title>
        <slot name="title">
          <div>Create a New Batch</div>
        </slot>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Batches represent the physical materials being coated or processed.
      </v-card-subtitle>
      <v-card-text>
        <v-form v-model="$v.valid" @submit.prevent="submit">
          <v-text-field
            v-model.trim="$v.formdata.name.$model"
            :error-messages="nameErrors"
            label="Batch Name or Title"
            counter="124"
            hint="Something that briefly describes this batch"
            prepend-icon="fas fa-id-card"
            @input="$v.formdata.name.$touch()"
            @blur="$v.formdata.name.$touch()"
          />
          <v-autocomplete
            v-model="$v.formdata.location_id.$model"
            :error-messages="locationErrors"
            label="Storage Location"
            :items="locations"
            :loading="loading"
            item-value="id"
            item-text="name"
            hint="Where are we storing this thing? You can add a new location in the field below if needed."
            append-icon="fas fa-map-marked-alt"
            prepend-icon="add_box"
            @click:prepend="showLocationForm = !showLocationForm"
            @input="$v.formdata.location_id.$touch()"
            @blur="$v.formdata.location_id.$touch()"
          />
          <v-row justify="center">
            <v-col sm="8" cols="8">
              <LocationFormNew v-show="showLocationForm"/>
            </v-col>
          </v-row>
          <v-text-field
            v-model="$v.formdata.coatedquantity.$model"
            :error-messages="quantityErrors"
            type="number"
            label="Coated Quantity"
            :suffix="formdata.units"
            counter="13"
            hint="How much coated material did we end up with?"
            :prepend-icon="formdata.coatedquantityIcon"
            @input="$v.formdata.coatedquantity.$touch()"
            @blur="$v.formdata.coatedquantity.$touch()"
          />
          <v-select
            v-model="$v.formdata.units.$model"
            :error-messages="unitErrors"
            label="Units"
            :items="units"
            prepend-icon="fas fa-dumbbell"
            @input="$v.formdata.units.$touch()"
            @blur="$v.formdata.units.$touch()"
          />
          <v-text-field
            v-model="$v.formdata.coatedcycles.$model"
            :error-messages="cycleErrors"
            type="number"
            label="Cycle Count"
            counter="6"
            hint="How many cycles did we do?"
            :prepend-icon="formdata.coatedcyclesIcon"
            @input="$v.formdata.coatedcycles.$touch()"
            @blur="$v.formdata.coatedcycles.$touch()"
          />
          <v-switch
            v-model="formdata.picoshield"
            label="Picoshield Batch"
            hint="Check this if you know this is desginated for picoshield"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="warning" text>
          <v-icon left>fas fa-redo</v-icon>
          Clear
        </v-btn>
        <v-btn text @click="dialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn text color="success" @click="submit" :disabled="$v.$invalid">
          <v-icon left>save</v-icon>
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Batch from "../../models/Batch";
import Location from "../../models/Location";
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import LocationFormNew from "../Locations/LocationFormNew";
export default {
  name: "BatchForm",
  components: { LocationFormNew },
  mixins: [validationMixin],
  validations: Batch.validations,
  props: {
    instance: {
      type: Object,
      default: () => {}
    },
    isDuplicate: {
      type: Boolean,
      required: true,
      default: false
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    workid: {
      type: [Number, String],
    }
  },
  data() {
    return {
      loading: true,
      dialog: false,
      showLocationForm: false,
      units: ["g", "kg", "mg", 'mL', 'L', "units"],
      formdata: new Batch(this.instance)
    };
  },
  computed: {
    // return error messages for validated fields
    nameErrors() {
      return handleErrors("formdata", "name", this);
    },
    quantityErrors() {
      return handleErrors("formdata", "coatedquantity", this);
    },
    cycleErrors() {
      return handleErrors("formdata", "coatedcycles", this);
    },
    locationErrors() {
      return handleErrors("formdata", "location_id", this);
    },
    unitErrors() {
      return handleErrors("formdata", "units", this);
    },
    // For location selection field
    locations() {
      return Location.query().orderBy('name').get();
    }
  },
  created() {
    Location.$fetch().then(() => (this.loading = false));
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.isEdit) {
        Batch
          .$put(this.instance.id, this.formdata.toUpdatePayload())
          .then(() => this.dialog = false)
      } else {
        this.formdata.workorder_id = this.workid;
        Batch
          .$post(this.formdata.toCreatePayload())
          .then(() => {
              this.clear();
              this.dialog = false;
            })
      }
    },
    clear() {
      this.formdata = new Batch();
      this.$v.$reset();
    }
  }
};
</script>

